import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { aPrecioDisplay, aPrecioNeto } from './preciosIvaDisplay';

const parseDecimalInput = (raw: string): number => {
  let normalized = String(raw ?? '').trim().replace(/[^0-9.,]/g, '').replace(/,/g, '.');
  const parts = normalized.split('.');
  if (parts.length > 2) {
    normalized = `${parts[0]}.${parts.slice(1).join('')}`;
  }
  if (normalized === '' || normalized === '.') return 0;
  const n = Number(normalized.endsWith('.') ? normalized.slice(0, -1) : normalized);
  return Number.isFinite(n) ? n : 0;
};

const formatDisplayValue = (value: number): string => {
  if (!Number.isFinite(value) || value === 0) return '';
  return String(value);
};

interface Props {
  precioNeto: number;
  preciosConIva: boolean;
  multiplicador: number;
  onChange: (precioNeto: number) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  readOnly?: boolean;
  sx?: object;
}

const POSPrecioUnitarioField: React.FC<Props> = ({
  precioNeto,
  preciosConIva,
  multiplicador,
  onChange,
  onKeyDown,
  inputProps,
  readOnly = false,
  sx,
}) => {
  const displayValue = preciosConIva
    ? aPrecioDisplay(precioNeto, multiplicador)
    : precioNeto;

  const [localValue, setLocalValue] = useState<string>(formatDisplayValue(displayValue));
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (!focused) {
      setLocalValue(formatDisplayValue(displayValue));
    }
  }, [displayValue, focused]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let raw = String(e.target.value ?? '');
    raw = raw.replace(/[^0-9.,]/g, '').replace(/,/g, '.');
    const parts = raw.split('.');
    if (parts.length > 2) {
      raw = `${parts[0]}.${parts.slice(1).join('')}`;
    }
    setLocalValue(raw);
  };

  const handleBlur = () => {
    setFocused(false);
    const parsed = parseDecimalInput(localValue);
    const precioNetoFinal = preciosConIva
      ? aPrecioNeto(parsed, multiplicador)
      : parsed;
    const displayFinal = preciosConIva
      ? aPrecioDisplay(precioNetoFinal, multiplicador)
      : precioNetoFinal;

    setLocalValue(formatDisplayValue(displayFinal));
    if (precioNetoFinal !== precioNeto) {
      onChange(precioNetoFinal);
    }
  };

  return (
    <TextField
      size="small"
      fullWidth
      type="text"
      value={localValue}
      onChange={handleChange}
      onFocus={() => setFocused(true)}
      onBlur={handleBlur}
      onKeyDown={onKeyDown}
      inputProps={{
        inputMode: 'decimal',
        ...inputProps,
      }}
      InputProps={{ readOnly }}
      sx={sx}
    />
  );
};

export default POSPrecioUnitarioField;
